import { en } from './en';
import { ja } from './ja';

export const locales = { en, ja };
export const defaultLanguage = 'en';
export const supportedLanguages = ['en', 'ja'];
